const MAX_RETRIES = 3; // maximum number of retries for fetching a URL
const RETRY_DELAY_MS = 600; // delay between retries in milliseconds

const delay = ms => new Promise(res => setTimeout(res, ms));

export const fetchJsonWithRetry = async (
  url,
  retries = MAX_RETRIES,
  attempt = 1
) => {
  try {
    const resp = await fetch(url);
    if (!resp.ok) throw new Error(`Status ${resp.status}`);
    return await resp;
  } catch (e) {
    if (attempt >= retries) {
      console.error("Sources fetch failed:", url, e);
      throw e;
    }
    await delay(RETRY_DELAY_MS * attempt);
    return fetchJsonWithRetry(url, retries, attempt + 1);
  }
};
